import { Autocomplete, Box, TextField } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react'
import { useBase64 } from '../../../../../hooks/useBase64';
import { useTranslation } from 'react-i18next';
import GenericPromises from '../../../../../api/GenericPromises';
import useSnackBar from '../../../../../components/Commons/SnackBar/useSnackBar';
import { useProjectTaskDashboardStore } from '../../../../../store/Projects/ProjectTaskDashboard/ProjectTaskDashboardStore';
import { AuthContext } from '../../../../../context/AuthContext';
import { useTaskStatesStore } from '../../../../../store/Projects/TaskStates/TaskStatesStore';

interface ComboOption {
    enum_id: number;
    option_name: string;
    route: string;
}

interface TaskFilterProps {
    setIsLoadingDataTable: React.Dispatch<React.SetStateAction<boolean>>
}

export const TaskStatesFilter = ({
    setIsLoadingDataTable
}: TaskFilterProps) => {
    const [t] = useTranslation("global");
    const { utf8ToBase64 } = useBase64();
    const { GenericGetResource } = GenericPromises();
    const { showSnackBar, SnackbarComponent } = useSnackBar();
    const setProjectTasks = useProjectTaskDashboardStore(store => store.setProjectTasks);
    const { user } = useContext(AuthContext);
    const pendingState = useTaskStatesStore(store => store.pendingTaskState);
    const doneState = useTaskStatesStore(store => store.doneTaskState);
    const [isLoadingComboEnum, setIsLoadingComboEnum] = useState(false);
    const [comboEnum, setComboEnum] = useState<ComboOption[]>([]);
    const [myEnumValue, setMyEnumValue] = useState<ComboOption>();
    const [defaultEnum, setDefaultEnum] = useState<ComboOption>();
    const [dataloaded, setDataLoaded] = useState(false);

    useEffect(() => {
        if (pendingState && doneState) {
            const newComboEnum = [
                { enum_id: 1, option_name: t("projecttaskdashboard.comboEnum.all"), route: `/projecttaskdashboard/evaluated/bygroupid/${utf8ToBase64(`${user?.group_id}`)}/byTaskStateName/${utf8ToBase64(`${null}`)}` },
                { enum_id: 2, option_name: t("projecttaskdashboard.comboEnum.onlypending"), route: `/projecttaskdashboard/evaluated/bygroupid/${utf8ToBase64(`${user?.group_id}`)}/byTaskStateName/${utf8ToBase64(`${pendingState?.task_state_name}`)}` },
                { enum_id: 3, option_name: t("projecttaskdashboard.comboEnum.onlydone"), route: `/projecttaskdashboard/evaluated/bygroupid/${utf8ToBase64(`${user?.group_id}`)}/byTaskStateName/${utf8ToBase64(`${doneState?.task_state_name}`)}` },
            ];
            setComboEnum(newComboEnum);
            setMyEnumValue(newComboEnum[1]);
            setDefaultEnum(newComboEnum[1]);
            setIsLoadingComboEnum(true);
        }
    }, [pendingState, doneState, user?.group_id]);

    useEffect(() => {
        if (myEnumValue && isLoadingComboEnum) {
            setIsLoadingDataTable(true);
            GenericGetResource(myEnumValue.route)
                .then(async (response) => {
                    setProjectTasks(response.data.data);
                    setIsLoadingDataTable(false);
                    setDataLoaded(true);
                })
                .catch((error) => {
                    showSnackBar(error.message, "error");
                });
        }
    }, [myEnumValue, isLoadingComboEnum])

    return (
        <>
            {dataloaded && (
                <div className="d-flex justify-content-end">
                    <Autocomplete
                        size="small"
                        options={comboEnum}
                        defaultValue={defaultEnum}
                        getOptionLabel={(option) => option.option_name}
                        renderOption={(props, option) => (
                            <div key={option.enum_id}>
                                <Box
                                    component="li"
                                    sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                                    {...props}
                                >
                                    {option.option_name}
                                </Box>
                            </div>
                        )}
                        sx={{ width: "20%", paddingRight: 1 }}
                        isOptionEqualToValue={(option, value) =>
                            option.enum_id === value.enum_id
                        }
                        onChange={(_, values) => {
                            setMyEnumValue(
                                values ?? {
                                    enum_id: 2, option_name: t("projecttaskdashboard.comboEnum.onlypending"), route: `/projecttaskdashboard/evaluated/bygroupid/${utf8ToBase64(`${user?.group_id}`)}/byTaskStateName/${utf8ToBase64(`${doneState?.task_state_name}`)}`
                                }
                            );
                        }}
                        renderInput={(params) => (
                            <TextField {...params}
                                label={`${t("generic.filter")}`}
                                variant="filled" />
                        )}
                        clearOnEscape={false}
                        clearIcon={null}
                    />
                </div>
            )}
        </>
    )
}
